export * from './TooltipForEllipsisElement';
